/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { ListingStatus, getEnumTitle } from '@zcode/enums'
import { PROP_NAMES } from '@zcode/mixpanel'
import { selectDisplayMedia } from '@zcode/nr/es/shared/bizos/rentable/selectors'
import { displayAmenity, displayBuildingAmenity } from '@zcode/nr/es/shared/utils/amenity'
import type { Property, State } from '@zcode/state-type'

export const getDetailProps = (state: State, entity: Property) => {
  const {
    bathrooms,
    bedrooms,
    catsOk,
    dateAvailable,
    description,
    dogsOk,
    isBuilding,
    price,
    squareFeet,
  } = entity

  const buildingAmenityLabels: string[] = []
  const listingAmenityLabels: string[] = []
  const buildingAmenities =
    entity.isBuilding && entity.listingId == null ? entity.amenities : entity.buildingAmenities
  if (buildingAmenities) {
    for (const amenity of buildingAmenities) {
      buildingAmenityLabels.push(displayBuildingAmenity(amenity))
    }
  }
  const listingAmenities = entity.isBuilding ? entity.unitAmenities : entity.amenities
  if (listingAmenities) {
    for (const amenity of listingAmenities) {
      listingAmenityLabels.push(displayAmenity(amenity))
    }
  }

  const displayMedia = selectDisplayMedia(entity)
  const media = displayMedia
  const status =
    entity.isBuilding && !entity.isFloorplan ? entity.buildingStatus : entity.listingStatus

  return {
    [PROP_NAMES.BUILDING_AMENITIES]: buildingAmenityLabels,
    [PROP_NAMES.BUILDING_PETS]: isBuilding ? !!(catsOk || dogsOk) : undefined,
    [PROP_NAMES.DESCRIPTION_LENGTH]: description?.length,
    [PROP_NAMES.LISTING_AMENITIES]: listingAmenityLabels,
    [PROP_NAMES.LISTING_AVAIL_DATE]: dateAvailable,
    [PROP_NAMES.LISTING_BATHS]: bathrooms,
    [PROP_NAMES.LISTING_BEDS]: bedrooms,
    [PROP_NAMES.LISTING_PETS]: !isBuilding ? !!(catsOk || dogsOk) : undefined,
    [PROP_NAMES.LISTING_PRICE]: price,
    [PROP_NAMES.NUM_IMAGES]: media?.length,
    [PROP_NAMES.SQUARE_FOOTAGE]: squareFeet,
    [PROP_NAMES.PROPERTY_STATUS]: getEnumTitle(ListingStatus, status),
  }
}
